export default "__VITE_ASSET__b8973368__"